import { types } from 'mobx-state-tree';
import Book from './Book';
import { productTypeMap } from "../utils/";

const Order = types.model("Order", {
  book: types.optional(Book, Book.create({})),
  currentStep: "info", // 男性から女性へのシカケテガミ用
  step: 0, // 男性から女性へのシカケテガミ用
  facesSaved: false, // 男性から女性へのシカケテガミ用
  storiesSaved: false, // 男性から女性へのシカケテガミ用
  currentStepParentToChild: "info", // 親から子へのシカケテガミ用
  stepParentToChild: 0, // 親から子へのシカケテガミ用
  facesSavedParentToChild: false, // 親から子へのシカケテガミ用
  storiesSavedParentToChild: false, // 親から子へのシカケテガミ用
  currentStepChildToParent: "info", // 子から親へのシカケテガミ用
  stepChildToParent: 0, // 子から親へのシカケテガミ用
  facesSavedChildToParent: false, // 子から親へのシカケテガミ用
  storiesSavedChildToParent: false, // 子から親へのシカケテガミ用
  currentStepFemaleToMale: "info", // 女性から男性へのシカケテガミ用
  stepFemaleToMale: 0, // 女性から男性へのシカケテガミ用
  facesSavedFemaleToMale: false, // 女性から男性へのシカケテガミ用
  storiesSavedFemaleToMale: false, // 女性から男性へのシカケテガミ用
}).actions(self => ({
  changeCurrentStep: s => {
    const productType = productTypeMap[self.book.productType];
    let currentStep = '';

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      self.currentStepParentToChild = s === self.currentStepParentToChild || s === undefined ? "-" : s;
      currentStep = self.currentStepParentToChild;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      self.currentStepChildToParent = s === self.currentStepChildToParent || s === undefined ? "-" : s;
      currentStep = self.currentStepChildToParent;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      self.currentStepFemaleToMale = s === self.currentStepFemaleToMale || s === undefined ? "-" : s;
      currentStep = self.currentStepFemaleToMale;
    } else {
      // 男性から女性へのシカケテガミ
      self.currentStep = s === self.currentStep || s === undefined ? "-" : s;
      currentStep = self.currentStep;
    }

    switch (currentStep) {
      case "-":
      case "info": window.scrollTo(0, 0); break;
      case "custom": window.scrollTo(0, 50); break;
      case "stories": window.scrollTo(0, 100); break;
      case "message": window.scrollTo(0, 150); break;
      case "panflet": window.scrollTo(0, 200); break;
    }
  },
  nextStep: () => {
    const productType = productTypeMap[self.book.productType];
    let currentStep = '';

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      currentStep = self.currentStepParentToChild;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      currentStep = self.currentStepChildToParent;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      currentStep = self.currentStepFemaleToMale;
    } else {
      // 男性から女性へのシカケテガミ
      currentStep = self.currentStep;
    }

    switch (currentStep) {
      case "info": self.changeCurrentStep("custom"); break;
      case "custom": self.changeCurrentStep("stories"); break;
      case "stories": self.changeCurrentStep("message"); break;
      case "message": self.changeCurrentStep("panflet"); break;
      case "panflet": self.changeCurrentStep("-"); break;
    }
  },
  changeFacesSaved: v => {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      self.facesSavedParentToChild = v;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      self.facesSavedChildToParent = v;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      self.facesSavedFemaleToMale = v;
    } else {
      // 男性から女性へのシカケテガミ
      self.facesSaved = v;
    }
  },
  saveFaces: () => {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      self.facesSavedParentToChild = true;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      self.facesSavedChildToParent = true;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      self.facesSavedFemaleToMale = true;
    } else {
      // 男性から女性へのシカケテガミ
      self.facesSaved = true;
    }
  },
  changeStoriesSaved: v => {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      self.storiesSavedParentToChild = v;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      self.storiesSavedChildToParent = v;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      self.storiesSavedFemaleToMale = v;
    } else {
      // 男性から女性へのシカケテガミ
      self.storiesSaved = v;
    }
  },
  saveStories: () => {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      self.storiesSavedParentToChild = true;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      self.storiesSavedChildToParent = true;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      self.storiesSavedFemaleToMale = true;
    } else {
      // 男性から女性へのシカケテガミ
      self.storiesSaved = true;
    }

    self.nextStep();
  }
})).views(self => ({
  get canShowCustom() {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      return self.book.parentToChild.isInfoSet;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      return self.book.childToParent.isInfoSet;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      return self.book.isInfoSetFemaleToMale;
    } else {
      // 男性から女性へのシカケテガミ
      return self.book.isInfoSet;
    }
  },
  get canShowStories() {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      const { parentToChild } = self.book;
      const childFace = parentToChild.childrenSex === "male" ? parentToChild.boyFace : parentToChild.girlFace;

      if (parentToChild.isSingle === "1") {
        // TODO: 判定は作者に依存している。増えたときに考慮必要かも
        const createFace = self.book.artistName === "nakagawa" ? parentToChild.papaFace : parentToChild.mamaFace;
        return self.canShowCustom &&
          childFace.isSet &&
          createFace.isSet &&
          self.facesSavedParentToChild;
      } else {
        return self.canShowCustom &&
          parentToChild.papaFace.isSet &&
          parentToChild.mamaFace.isSet &&
          self.facesSavedParentToChild;
      }
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      const { childToParent } = self.book;
      if (childToParent.receiver === "dad") { // 父親宛て
        return self.canShowCustom &&
          childToParent.dadFace.isSet &&
          childToParent.creatorFace.isSet &&
          self.facesSavedChildToParent;
      } else if (childToParent.receiver === "mom") { // 母親宛て
        return self.canShowCustom &&
          childToParent.momFace.isSet &&
          childToParent.creatorFace.isSet &&
          self.facesSavedChildToParent;
      } else { // 両親宛て
        return self.canShowCustom &&
          childToParent.dadFace.isSet &&
          childToParent.momFace.isSet &&
          childToParent.creatorFace.isSet &&
          self.facesSavedChildToParent;
      }
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      return self.canShowCustom &&
        self.book.creatorFace.isSet &&
        self.book.receiverFace.isSet &&
        self.facesSavedFemaleToMale;
    } else {
      // 男性から女性へのシカケテガミ
      return self.canShowCustom &&
        self.book.creatorFace.isSet &&
        self.book.receiverFace.isSet &&
        self.facesSaved;
    }
  },
  get canShowMessage() {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      return self.canShowStories && self.storiesSavedParentToChild && self.book.parentToChild.areStoriesSet;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      return self.canShowStories && self.storiesSavedChildToParent && self.book.childToParent.areStoriesSet;
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      return self.canShowStories && self.storiesSavedFemaleToMale && self.book.areStoriesSet;
    } else {
      // 男性から女性へのシカケテガミ
      return self.canShowStories && self.storiesSaved && self.book.areStoriesSet;
    }
  },
  get canShowPanflet() {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      return self.canShowMessage &&
        self.book.parentToChild.personalMessage.join('') !== '' &&
        self.book.parentToChild.personalFont !== '';
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      return self.canShowMessage &&
        self.book.childToParent.personalMessage.join('') !== '' &&
        self.book.childToParent.personalFont !== '';
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      return self.canShowMessage &&
        self.book.personalMessage.join('') !== '' &&
        self.book.personalFont !== '';
    } else {
      // 男性から女性へのシカケテガミ
      return self.canShowMessage &&
        self.book.personalMessage.join('') !== '' &&
        self.book.personalFont !== '';
    }
  },
  get canShowPreview() {
    const productType = productTypeMap[self.book.productType];

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      return self.canShowPanflet &&
        self.book.parentToChild.bandId !== -1;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      return self.canShowPanflet &&
        self.book.childToParent.blurbText !== 0
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      return self.canShowPanflet &&
        self.book.blurbText !== 0;
    } else {
      // 男性から女性へのシカケテガミ
      return self.canShowPanflet &&
        self.book.blurbText !== 0;
    }
  }
}));

export default Order;



// WEBPACK FOOTER //
// ./src/models/Order.js